var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.214 1.4826C15.1275 1.28256 14.984 1.1124 14.8015 0.99326C14.619 0.874121 14.4054 0.811268 14.1875 0.812518H1.81248C1.59475 0.812947 1.38181 0.876552 1.19951 0.995617C1.01722 1.11468 0.873387 1.28409 0.785474 1.48329C0.697561 1.68249 0.669343 1.90292 0.704244 2.11784C0.739144 2.33276 0.835663 2.53294 0.982091 2.69408L0.987716 2.70041L5.74998 7.78541V13.1875C5.74993 13.3911 5.80514 13.5909 5.90973 13.7656C6.01431 13.9403 6.16434 14.0834 6.34383 14.1795C6.52332 14.2756 6.72553 14.3212 6.92891 14.3115C7.13228 14.3017 7.3292 14.237 7.49865 14.1241L9.74865 12.6236C9.90289 12.5209 10.0294 12.3816 10.1168 12.2182C10.2043 12.0548 10.25 11.8724 10.25 11.687V7.78541L15.0129 2.70041L15.0186 2.69408C15.1665 2.53367 15.264 2.33323 15.2988 2.11778C15.3335 1.90232 15.3041 1.68141 15.214 1.4826ZM9.27826 7.18142C9.18095 7.28459 9.12621 7.42071 9.12498 7.56252V11.687L6.87498 13.1875V7.56252C6.87502 7.41968 6.82073 7.28218 6.72311 7.17791L1.81248 1.93752H14.1875L9.27826 7.18142Z",
    fill: "#393939"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.e9629e7745b3392cf35ebc448b2311be.svg";
export { ForwardRef as ReactComponent };